@if (storesInitialized) {
  @if (!userStore.isGuestView()) {
    <app-bookmark-menu
      (loadLayout)="onLoadLayout($event)"
      [activeTopic]="globalStore.activeTopic()"></app-bookmark-menu>
  }

  @if (showLandingPage) {
    <app-atlas-landingpage />
  }

  <h2 class="md:flex align-items-center gap-2 py-0 my-1 mx-1">
    <div class="md:flex align-items-center gap-2 flex-grow-1">
      @if (activeCommune?.atlasConfig?.logo) {
        <div class="md:h-5rem surface-0 p-3 border-round-xl">
          <app-logo variant="icon" hStyleClass="h-3rem w-4rem" />
        </div>
      }

      <div class="md:h-5rem surface-0 p-3 border-round-xl">
        <app-logo
          hStyleClass="h-3rem w-8rem"
          [logoFileName]="activeCommune?.atlasConfig?.logo" />
      </div>
      <div
        class="md:h-5rem surface-0 p-3 border-round-xl flex flex-column gap-1 flex-grow-1">
        @if (
          activeBookmark?.headline || activeBookmark?.title;
          as bookmarkHeadline
        ) {
          <div class="flex align-items-baseline gap-2">
            <div class="flex flex-column">
              <span
                class="text-primary"
                [class]="bookmarkHeadline.length > 30 ? 'text-lg' : 'text-xl'"
                >{{ bookmarkHeadline }}</span
              >
              <div class="text-color-secondary font-light text-base">
                {{ activeCommune?.title || activeCommune?.name }}
              </div>
            </div>
          </div>
        } @else {
          {{ activeCommune?.title || activeCommune?.name }}
        }
      </div>
    </div>

    @if (gridStore.layout() && gridStore.layout().length > 0) {
      <div
        class="md:h-5rem hidden sm:flex ml-auto gap-2 surface-0 p-3 border-round-xl">
        <app-atlas-year-controls [disableControls]="disableControls" />
      </div>
    }
  </h2>

  <app-atlas-grid gridId="main"></app-atlas-grid>

  <router-outlet name="reports"></router-outlet>

  @if (globalStore.openReport()) {
    <app-district-report
      [dataLayerId]="globalStore.activeReport()?.dataLayerId"
      [districtKey]="
        globalStore.activeReport()?.districtKey
      "></app-district-report>
  }

  @if (gridStore.showBookmarkForm() || gridStore.bookmarkToEdit()) {
    <p-sidebar
      (onHide)="gridStore.closeBookmarkForm()"
      [modal]="true"
      [visible]="gridStore.showBookmarkForm()"
      [styleClass]="'w-30rem'">
      <ng-template pTemplate="header">
        <app-header
          icon="fas fa-note-sticky"
          text="Ansicht speichern"></app-header
      ></ng-template>
      <app-bookmark-form
        [cancelLevel]="0"
        [bookmark]="gridStore.bookmarkToEdit()"
        [atlasForm]="true"
        (formSubmitted)="gridStore.closeBookmarkForm()"
        (cancel)="gridStore.closeBookmarkForm()"
        [layoutOptions]="gridStore.options() || null"
        [layout]="gridStore.layout()"></app-bookmark-form>
    </p-sidebar>
  }

  @if (showIndicatorInfoOverlay) {
    <p-sidebar
      (onHide)="onIndicatorInfoOverlayClose()"
      [modal]="true"
      [visible]="!!infoIndicator || !!globalStore.selectedWidget()"
      [styleClass]="'w-30rem'">
      <ng-template pTemplate="headless">
        <app-info
          [indicators]="infoIndicator ? [infoIndicator] : null"
          [id]="selectedWidgetId || ''" />
      </ng-template>
    </p-sidebar>
  }

  @if (globalStore.activeStory(); as storyId) {
    <app-story-gallery [storyId]="storyId" />
  }

  <p-dialog [(visible)]="addNewColorsetDialog" [style]="{ width: '80rem' }">
    <ng-template pTemplate="header">
      <app-header
        styleClass="m-0"
        icon="fas fa-plus-circle"
        text="Farbset hinzufügen"></app-header>
    </ng-template>
    @if (addNewColorsetDialog) {
      <app-colorset-form
        [cancelLevel]="0"
        (cancel)="addNewColorsetDialog = false"
        (formSubmitted)="addNewColorsetDialog = false"></app-colorset-form>
    }
  </p-dialog>

  <p-dialog
    [(visible)]="addNewBookmarkCategoryDialog"
    [style]="{ width: '50rem' }">
    <ng-template pTemplate="header">
      <app-header
        styleClass="m-0"
        icon="fas fa-plus-circle"
        text="Themenbereich hinzufügen"></app-header>
    </ng-template>
    @if (addNewBookmarkCategoryDialog) {
      <app-bookmark-category-form
        [cancelLevel]="0"
        (cancel)="closeBookmarkCategoryDialog()"
        (formSubmitted)="
          addNewBookmarkCategoryDialog = false
        "></app-bookmark-category-form>
    }
  </p-dialog>

  <p-dialog
    styleClass="z-top"
    maskStyleClass="z-top"
    appendTo="body"
    [(visible)]="!!addWorkspaceDialog"
    [style]="{ width: '40rem' }">
    <ng-template pTemplate="header">
      <app-header
        styleClass="m-0"
        icon="fas fa-plus-circle"
        text="Arbeitsbereich hinzufügen"></app-header>
    </ng-template>
    @if (!!addWorkspaceDialog) {
      <app-workspace-form
        [type]="this.addWorkspaceDialog || undefined"
        [cancelLevel]="0"
        (cancel)="addWorkspaceDialog = ''"
        (formSubmitted)="addWorkspaceDialog = ''"></app-workspace-form>
    }
  </p-dialog>
} @else {
  <div class="p-8">
    <div class="flex gap-3 align-content-center">
      <p-skeleton width="12rem" height="10rem" />
      <div class="flex flex-column gap-3">
        <p-skeleton width="50rem" height="3rem" />
        <p-skeleton width="44rem" />
        <p-skeleton width="40rem" />
      </div>
    </div>
    <div class="flex gap-5 mt-5">
      <div class="flex flex-column gap-3 flex-wrap">
        <p-skeleton width="20rem" height="11rem" />
        <p-skeleton width="20rem" height="11rem" />
      </div>
      <div class="flex gap-3 flex-wrap">
        <p-skeleton width="20rem" height="11rem" />
        <p-skeleton width="20rem" height="11rem" />
        <p-skeleton width="20rem" height="11rem" />
        <p-skeleton width="20rem" height="11rem" />
        <p-skeleton width="20rem" height="11rem" />
        <p-skeleton width="20rem" height="11rem" />
      </div>
    </div>
  </div>
}
